export const getWebsiteHost = () => location.protocol + '//' + location.host

export const getSanitizedReturnLocation = (url: string) => {
  try {
    const websiteHost = getWebsiteHost()
    const parsedUrl = new URL(url, websiteHost)

    return parsedUrl.origin === websiteHost ? parsedUrl.href : websiteHost
  } catch (error) {
    return getWebsiteHost()
  }
}
